
import { v4 as uuidv4 } from "uuid";

export class CreatureHP { 
  true_id = "hp";
  called = "Hit Points";
  current = 0;
  max = 0;
  override_max: number | null = null;
  max_modifier = 0;
  temp = 0;
  death_save_fails = 0;
  death_save_successes = 0;
  allow_negative = false;
  calc_steps: string[] = [];

  constructor(obj?: any) {
    this.true_id = obj && obj.true_id ? obj.true_id : uuidv4().toString();
    // console.log(obj);
    if (obj) {
      this.called = obj.called ? obj.called : "Hit Points";
      this.current = obj.current ? obj.current : 0;
      this.max = obj.max ? obj.max : 0;
      this.override_max = obj.override_max && obj.override_max > -1 ? obj.override_max : null;
      
      this.max_modifier = obj.max_modifier ? obj.max_modifier : 0;
      this.temp = obj.temp ? obj.temp : 0;
      this.death_save_fails = obj.death_save_fails ? obj.death_save_fails : 0;
      this.death_save_successes = obj.death_save_successes ? obj.death_save_successes : 0;
      this.allow_negative = obj.allow_negative ? obj.allow_negative : false;
    }
  }

  get true_max() {
    if (this.override_max) {
      return this.override_max;
    } else {
      return this.max + this.max_modifier;
    }
  }

  toDBObj() {
    return {
      true_id: this.true_id,
      called: this.called,
      current: this.current,
      max: this.max,
      override_max: this.override_max,
      max_modifier: this.max_modifier,
      temp: this.temp,
      death_save_fails: this.death_save_fails,
      death_save_successes: this.death_save_successes,
      allow_negative: this.allow_negative
    };
  }

  copy(copyMe: CreatureHP) {
    this.called = copyMe.called;
    this.current = copyMe.current;
    this.max = copyMe.max;
    this.override_max = copyMe.override_max;
    this.max_modifier = copyMe.max_modifier;
    this.temp = copyMe.temp;
    this.death_save_fails = copyMe.death_save_fails;
    this.death_save_successes = copyMe.death_save_successes;
    this.allow_negative = copyMe.allow_negative;
  }
  
  clone() {
    const clone = new CreatureHP();
    clone.copy(this);
    return clone;
  }
}
